// Mock data per La Bottega Dei Briganti

export const restaurantInfo = {
  name: "La Bottega Dei Briganti",
  tagline: "Rigorosamente Italiano",
  description: "Materie prime selezionate per darvi solo il meglio",
  phone: "+39 0522 886705",
  email: "info@bottegadeibriganti.it",
  address: {
    street: "Via Salvador Allende 1/A",
    city: "Montecavolo (Quattro Castella)",
    province: "Reggio Emilia",
    zip: "42020",
    country: "Italia"
  },
  hours: {
    lunch: "Martedì-Venerdì: 12:00-14:15",
    aperitivo: "Martedì-Domenica: 18:00-19:00",
    dinner: "Martedì-Domenica: 19:00-22:30",
    closed: "Lunedì"
  },
  menuPdfUrl: "https://menu.menumal.com/bottegadeibriganti",
  bookingUrl: "https://labottegadeibriganti.plateform.app/welcome"
};

export const aboutContent = {
  title: "Benvenuti alla Bottega dei Briganti",
  subtitle: "Siamo un'hamburgeria con una filosofia",
  paragraphs: [
    "Le nostre materie prime vengono per lo più da realtà locali: le nostre carni non provengono da allevamenti intensivi e la ricetta dei nostri hamburger è creata da noi, utilizzando tagli selezionati e mirati, in modo che la carne diventi più digeribile.",
    "Il pane viene sfornato quotidianamente e contiene una percentuale di farina di Teff, perciò è a basso contenuto di glutine, sempre croccante fuori e morbido all'interno.",
    "Le nostre verdure sono sempre fresche e nei mesi estivi utilizziamo prodotti dell'orto. Le birre provengono per la maggior parte da birrifici artigianali che lavorano sul nostro territorio.",
    "Con il nostro impegno e la nostra passione abbiamo creato un prodotto unico, che riempie le vostre pance ma anche i vostri sensi."
  ],
  features: [
    {
      title: "Materie Prime Locali",
      description: "Carni selezionate da allevamenti non intensivi del territorio"
    },
    {
      title: "Pane Artigianale",
      description: "Sfornato quotidianamente con farina di Teff a basso contenuto di glutine"
    },
    {
      title: "Birre Artigianali",
      description: "Selezione accurata da birrifici locali e nazionali"
    },
    {
      title: "Verdure Fresche",
      description: "Prodotti dell'orto nei mesi estivi per garantire freschezza"
    }
  ]
};

export const events = [
  {
    id: 1,
    title: "BOTTEGA HOUSE PARTY",
    date: "24 Aprile 2024",
    description: "Una serata speciale con musica house e ottimi drink",
    image: "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3"
  },
  {
    id: 2,
    title: "COVER MAKERS",
    date: "27 Marzo 2024",
    description: "Band live che reinterpreta i grandi classici della musica",
    image: "https://images.unsplash.com/photo-1501612780327-45045538702b"
  },
  {
    id: 3,
    title: "FRIDAY MUSIC VINILI",
    date: "Ogni Venerdì",
    description: "Musica da vinile per accompagnare la vostra cena",
    image: "https://images.unsplash.com/photo-1514525253161-7a46d19cd819"
  },
  {
    id: 4,
    title: "JAM SESSION",
    date: "Mercoledì Sera",
    description: "Serata di musica live durante l'inverno",
    image: "https://images.unsplash.com/photo-1511735111819-9a3f7709049c"
  }
];

export const specialties = [
  {
    name: "Hamburger Gourmet",
    description: "Ricetta unica con carni selezionate e tagli mirati"
  },
  {
    name: "Secondi di Carne",
    description: "Carni pregiate da allevamenti locali"
  },
  {
    name: "Insalate Fresche",
    description: "Con verdure di stagione dall'orto"
  },
  {
    name: "Birre Artigianali",
    description: "Ampia selezione di birrifici locali"
  }
];
